<template>
  <div>
    <NavBar></NavBar>
    <ImageDimension @sendSheetImgInfo="getSheetImgInfo" @sendMeasures="getOtherMeasures"></ImageDimension>
    <div class="row align-items-center">
      <div class="col-12 col-sm-4">
        <RawMaterialArea @lengthChanged="getLengthChange" @widthChanged="getWidthChange"
          :getInitialLengthConception="imgInitialLengthConception"></RawMaterialArea>
      </div>
      <div class="col-12 col-sm-8">
        <RawMateralSpeci @sendSheetTypeId="getsheetTypeId" @sendKiloPrice="getSheetKiloPrice" :getLength="lengthValue"
          :getWidth="widthValue" @sendWeight="getWeigthValue" @sendPriceConstant="getPriceConstant"
          @sendCommercialMm="getCommercialMm"></RawMateralSpeci>
      </div>
    </div>
    <ServicesSheet :getMainSheetType="sheetTypeId" :getSheetImageInfo="sheetImgInfo" :getLengthValue="lengthValue"
      :getWidthValue="widthValue" :getWeight="weigthValue" @sendServicesPrice="getServicesPrice"
      :getMeasures="measuresValues"></ServicesSheet>
    <SheetPrice :getKiloPrice="sheetKiloPrice" :getWeightUnit="weigthValue" :getFinalServicesPrice="priceServices"
      :getLengthValue="lengthValue" :getWidthValue="widthValue" :getPriceConstant="priceConstant"
      :getCommercialMm="commercialMm" :getFormName="formName"></SheetPrice>
  </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
import ImageDimension from "@/components/SheetQuote/ImageDimensionsComponent.vue";
import RawMaterialArea from "@/components/SheetQuote/RawMaterialAreaComponent.vue";
import RawMateralSpeci from "@/components/SheetQuote/RawMaterialSpecificationComponent.vue";
import ServicesSheet from "@/components/SheetQuote/ServicesSheetQuoteComponent.vue";
import SheetPrice from "@/components/SheetQuote/SheetPriceComponent.vue";
export default {
  data() {
    return {
      sheetImgInfo: [],
      measuresValues: [],
      sheetTypeId: null,
      sheetKiloPrice: null,
      lengthValue: null,
      widthValue: null,
      weigthValue: null,
      priceServices: null,
      priceConstant: null,
      commercialMm: null,
      //Variables de la imagen que se relacionan con otros componentes
      formName: "",
      imgInitialLengthConception: "",
    };
  },
  components: {
    NavBar,
    ImageDimension,
    RawMaterialArea,
    RawMateralSpeci,
    ServicesSheet,
    SheetPrice,
  },
  methods: {
    getWeigthValue(data) {
      this.weigthValue = data;
      //console.log(this.weigthValue);
    },
    getOtherMeasures(data) {
      // this.diametersValue=data.diameters;
      // this.radiusValue=data.radius;
      this.measuresValues = data;
      //console.log(this.measuresValues);
      //console.log(this.diametersValue);
      //console.log(this.radiusValue);
    },
    getsheetTypeId(data) {
      //Recibir parametros del emit de un hijo a el padre
      this.sheetTypeId = data;
      //console.log(this.sheetTypeId);
    },
    getSheetKiloPrice(data) {
      this.sheetKiloPrice = data;

      console.log('Desde el padre osea la vista G' + this.sheetKiloPrice);
    },
    getLengthChange(data) {
      this.lengthValue = data;
      // console.log(this.lengthValue);
    },
    getWidthChange(data) {
      this.widthValue = data;
      // console.log(this.widthValue);
    },
    getSheetImgInfo(data) {
      this.sheetImgInfo = data;
      //console.log(this.sheetImgInfo);
      this.formName = this.sheetImgInfo.imgForm;
      this.imgInitialLengthConception = this.sheetImgInfo.imgConceptionLength;
      //console.log(this.imgInitialLengthConception);
      //console.log(this.formName);
    },
    getServicesPrice(data) {
      this.priceServices = data;
      console.log(this.priceServices);
    },
    getPriceConstant(data) {
      this.priceConstant = data;
      //console.log(this.priceConstant);
    },
    getCommercialMm(data) {
      this.commercialMm = data;
      //console.log(this.commercialMm);
    },
  },
};
</script>
<style scoped></style>